module.exports = __webpack_public_path__ + "img/proposal.66d624ac.png";